import { c as _c } from "react/compiler-runtime";
import { Box, type BoxProps, LinearProgress } from "@mui/material";
import React, { type Ref } from "react";
import { MainAppBar, type MainAppBarProps } from "#/features/appBar/ui/MainAppBar";
import { Footer } from "#/shared/ui/organisms/Footer";
import { PageScrollContainer, type PageScrollContainerProps } from "#/shared/ui/templates/PageScrollContainer";
export type MainLayoutProps = Omit<BoxProps, "onScroll"> & {
  children: React.ReactNode;
  isLoading?: boolean;
  headerPosition?: MainAppBarProps["position"];
  onScroll?: PageScrollContainerProps["onScroll"];
  pageScrollViewportRef?: Ref<HTMLDivElement | null>;
};
export const MainLayout: React.FC<MainLayoutProps> = t0 => {
  const $ = _c(26);
  let children;
  let isLoading;
  let onScroll;
  let pageScrollViewportRef;
  let restProps;
  let t1;
  if ($[0] !== t0) {
    ({
      children,
      isLoading,
      headerPosition: t1,
      onScroll,
      pageScrollViewportRef,
      ...restProps
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = isLoading;
    $[3] = onScroll;
    $[4] = pageScrollViewportRef;
    $[5] = restProps;
    $[6] = t1;
  } else {
    children = $[1];
    isLoading = $[2];
    onScroll = $[3];
    pageScrollViewportRef = $[4];
    restProps = $[5];
    t1 = $[6];
  }
  const headerPosition = t1 === undefined ? "sticky" : t1;
  let t2;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      height: "100vh"
    };
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  let t3;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      minHeight: "100vh"
    };
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== headerPosition) {
    t4 = <MainAppBar position={headerPosition} />;
    $[9] = headerPosition;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = {
      minHeight: "85vh"
    };
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== children || $[13] !== isLoading) {
    t6 = isLoading ? <LinearProgress variant="indeterminate" /> : children;
    $[12] = children;
    $[13] = isLoading;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] !== t6) {
    t7 = <Box component="main" sx={t5}>{t6}</Box>;
    $[15] = t6;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  let t8;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <Footer />;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  let t9;
  if ($[18] !== restProps || $[19] !== t4 || $[20] !== t7) {
    t9 = <Box sx={t3} {...restProps}>{t4}{t7}{t8}</Box>;
    $[18] = restProps;
    $[19] = t4;
    $[20] = t7;
    $[21] = t9;
  } else {
    t9 = $[21];
  }
  let t10;
  if ($[22] !== onScroll || $[23] !== pageScrollViewportRef || $[24] !== t9) {
    t10 = <PageScrollContainer isPage={true} style={t2} onScroll={onScroll} viewportRef={pageScrollViewportRef}>{t9}</PageScrollContainer>;
    $[22] = onScroll;
    $[23] = pageScrollViewportRef;
    $[24] = t9;
    $[25] = t10;
  } else {
    t10 = $[25];
  }
  return t10;
};